import styled from "styled-components";

export const Excluir = styled.a`
`